export default __webpack_public_path__ + "static/media/ElipseWhite.6aa10372.svg";